import React, { useCallback, useContext } from 'react'
import SectionFormContainer from '../../components/SectionFormContainer'
import GroomingProfileWizardContext from './GroomingProfileWizardContext'
import BreedPicker from './components/BreedPicker'
import BreedsContext from './BreedsContext'
import { getAllowedGroomingServicesForPet } from './helpers'
import { GROOMING_PROFILE_KEYS } from './constants'

const SingleBreed = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(GroomingProfileWizardContext)
	const {
		breedsContextProvider: { breeds }
	} = useContext(BreedsContext)
	const { attr, title = '', subtext = '' } = props

	const handleSelection = useCallback(
		(breed) => {
			const breedInfo = breeds[breed] || null

			const newValues = { ...wizard_state }
			newValues[attr] = [breed]
			newValues[GROOMING_PROFILE_KEYS.coat_type] = breedInfo?.coat_type || ''
			newValues[GROOMING_PROFILE_KEYS.coat_length] = breedInfo?.coat_length || ''
			newValues[GROOMING_PROFILE_KEYS.grooming_level] = breedInfo?.grooming_level || ''

			const allowed_grooming_services = getAllowedGroomingServicesForPet(
				newValues[GROOMING_PROFILE_KEYS.grooming_level]
			)
			newValues[GROOMING_PROFILE_KEYS.allowed_grooming_services] = allowed_grooming_services

			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr, breeds]
	)

	return (
		<SectionFormContainer
			title={title}
			subtext={subtext}
			titleStyles={{ flex: 0, marginBottom: '1rem' }}
			childrenContainerStyles={{ flex: 0, marginBottom: '5rem' }}>
			<BreedPicker value={wizard_state[attr][0] || ''} onSelected={handleSelection} />
		</SectionFormContainer>
	)
}

export default SingleBreed
